import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import IssueReporter from '../../support/IssueReporter';
import SuggestionReporter from '../../support/SuggestionReporter';
import ReleaseNotes from '../../support/ReleaseNotes';
import { useThemeMode } from '../../../themeMode';

const ALBERTDESK_PORTAL_URL = process.env.REACT_APP_ALBERTDESK_PORTAL_URL || '';

export default function AppbarActions({
  isAuthenticated,
  isDesktop,
  user,
  onLogout,
  onNavigate,
}) {
  const { isDark, toggleMode } = useThemeMode();

  const resolveAlbertDeskSsoUrl = React.useCallback(() => {
    if (!ALBERTDESK_PORTAL_URL) return null;
    if (typeof window === 'undefined') return null;
    try {
      const url = new URL(ALBERTDESK_PORTAL_URL, window.location.origin);
      const normalizedPath = (url.pathname || '').replace(/\/+$/, '');
      if (normalizedPath === '/sso/keycloak' || normalizedPath === '/sso/schreiberlein') {
        return url.toString();
      }
      url.pathname = '/sso/keycloak';
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch {
      return null;
    }
  }, []);

  const openAlbertDeskPortal = React.useCallback(() => {
    const ssoUrl = resolveAlbertDeskSsoUrl();
    if (!ssoUrl) return;
    window.open(ssoUrl, '_blank', 'noopener,noreferrer');
  }, [resolveAlbertDeskSsoUrl]);

  return (
    <>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mr: 2}}>
        {isAuthenticated && ALBERTDESK_PORTAL_URL && (
          <Tooltip title="Meine Tickets">
            <Button
              color="inherit"
              size="small"
              aria-label="Meine Tickets"
              startIcon={<ConfirmationNumberOutlinedIcon />}
              onClick={openAlbertDeskPortal}
            >
              Meine Tickets
            </Button>
          </Tooltip>
        )}
        <ReleaseNotes isAuthenticated={isAuthenticated} compact={!isDesktop} />
        <IssueReporter isAuthenticated={isAuthenticated} reporter={user} compact={!isDesktop} />
        <SuggestionReporter isAuthenticated={isAuthenticated} reporter={user} compact={!isDesktop} />
        <Tooltip title={isDark ? 'Lightmode aktivieren' : 'Darkmode aktivieren'}>
          <IconButton color="inherit" size="small" onClick={toggleMode} aria-label="Theme umschalten">
            {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
      </Box>
      <Stack direction="row" spacing={1} alignItems="center">
        {isAuthenticated ? (
          <Button onClick={onLogout} color="inherit" sx={{fontWeight: 600}}>
            Logout
          </Button>
        ) : (
          <>
            <Button color="inherit" onClick={() => onNavigate('/login')} sx={{fontWeight: 600}}>
              Login
            </Button>
            <Button
              variant="contained"
              onClick={() => onNavigate('/registration')}
              sx={{
                bgcolor: '#000',
                color: '#fff',
                '&:hover': {bgcolor: '#333'},
                borderRadius: 2,
                display: {xs: 'none', sm: 'flex'},
              }}
            >
              Jetzt starten
            </Button>
          </>
        )}
      </Stack>
    </>
  );
}
